import React from 'react';
import times from 'lodash/times';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { TableBody } from '@material-ui/core';
import Skeleton from './../Skeleton/Typography';
import { TableWrapper, StyledTable } from './styles';

function renderCell(i, skeletonProps) {
  return /*#__PURE__*/React.createElement(TableCell, {
    key: i
  }, /*#__PURE__*/React.createElement(Skeleton, Object.assign({
    width: 100
  }, skeletonProps)));
}

export function SortableTableSkeleton(_ref) {
  var rowCount = _ref.rowCount,
      columnCount = _ref.columnCount,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(TableWrapper, {
    className: className
  }, /*#__PURE__*/React.createElement(StyledTable, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, times(columnCount, renderCell))), /*#__PURE__*/React.createElement(TableBody, null, times(rowCount, function (i) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: i
    }, times(columnCount, function (j) {
      return renderCell(j, {
        color: 'skeletonDark'
      });
    }));
  }))));
}
SortableTableSkeleton.defaultProps = {
  rowCount: 4,
  columnCount: 4
};
export default SortableTableSkeleton;